<template>
    <div class="tab-general-info">
        <div class="smalltitle blockcont">General Information</div>
        <div class="blockcont">
            <form>
                <div class="prolabel">First Name</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.firstName" maxlength="100"
                           :disabled="disabledForm">
                </div>
                <div class="prolabel">Last Name</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.lastName" maxlength="100"
                           :disabled="disabledForm"></div>
                <div class="prolabel">Display Name</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.displayName" maxlength="150"
                           :disabled="disabledForm"></div>
                <div class="prolabel">Title</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.title" maxlength="150"
                           :disabled="disabledForm"></div>
                <div class="prolabel">Day of Birth</div>
                <div class="profield">
                    <div class="row">
                        <div class="col-xs-4">
                            <select v-model="generalInfo.selectedDay" :disabled="disabledForm">
                                <option :value="generalInfo.selectedDay"> {{generalInfo.selectedDay}}</option>
                            </select>
                        </div>
                        <div class="col-xs-4">
                            <select v-model="generalInfo.selectedMonth" :disabled="disabledForm">
                                <option :value="generalInfo.selectedMonth"> {{generalInfo.selectedMonth}}</option>
                            </select></div>
                        <div class="col-xs-4">
                            <select v-model="generalInfo.selectedYear" :disabled="disabledForm">
                                <option :value="generalInfo.selectedYear"> {{generalInfo.selectedYear}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="prolabel">Gender</div>
                <div class="profield checkbox">
                    <input type="radio" id="malechoice" v-model="generalInfo.sex" value="male" :disabled="disabledForm">
                    <label for="malechoice">Male</label>
                    <input type="radio" id="femalechoice" v-model="generalInfo.sex" value="female"
                           :disabled="disabledForm">
                    <label for="femalechoice">Female</label>
                    <input type="radio" id="nochoice" v-model="generalInfo.sex" value="noanswer"
                           :disabled="disabledForm">
                    <label for="nochoice">Prefer not to answer</label>
                </div>
                <div class="prolabel">Ethnicity</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.ethnicity" maxlength="100"
                           :disabled="disabledForm">
                </div>
                <div class="prolabel">Marital Status</div>
                <div class="profield">
                    <select v-model="generalInfo.maritalStatus" :disabled="disabledForm">
                        <option :value="status.code" v-for="status in MARITAL_STATUS">{{status.name}}</option>
                    </select>
                </div>
                <div class="prolabel">Address</div>
                <div class="profield">
                    <div class="row">
                        <div class="col-xs-12">
                            <input type="text" placeholder="Address" :disabled="disabledForm"
                                   v-model="generalInfo.streetNumber" maxlength="255">
                        </div>
                        <!--<div class="col-xs-4">-->
                            <!--<input type="text" placeholder="Street name" :disabled="disabledForm"-->
                                   <!--v-model="generalInfo.streetName" maxlength="255">-->
                        <!--</div>-->
                        <!--<div class="col-xs-4">-->
                            <!--<input type="text" placeholder="Suite" :disabled="disabledForm"-->
                                   <!--v-model="generalInfo.suite" maxlength="15">-->
                        <!--</div>-->
                    </div>
                    <div class="row">
                        <div class="col-xs-4">
                            <input title="Type your city" placeholder="City" type="text" :disabled="disabledForm"
                                   v-model="generalInfo.city" maxlength="100"/>
                        </div>
                        <div class="col-xs-4">
                            <select v-model="generalInfo.state" :disabled="disabledForm">
                                <option value="" disabled selected>State</option>
                                <option :value="state.code" v-for="state in STATE">{{state.name}}</option>
                            </select>
                        </div>
                        <div class="col-xs-4">
                            <input type="text" placeholder="Zip Code" :disabled="disabledForm"
                                                     v-model="generalInfo.zipcode" maxlength="10">
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>

                <div class="prolabel">Introduction</div>
                <div class="profield">
                    <div style="border: 1px solid #e1e1e1;padding: 8px 10px;background: #efefef;" v-html="generalInfo.introdution" :disabled="disabledForm"></div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import config from '../../../../config'
import moment from 'moment'
export default {
  name: 'TabAccountSetting',
  components: {},
  props: {
    userInfo: {},
    profile: {},
    disabledForm: {}
  },
  mixins: [],
  data () {
    return {
      generalInfo: {},
      MARITAL_STATUS: config.MARITAL_STATUS,
      STATE: config.STATE
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  mounted () {
    if (this.userInfo) {
      this.generalInfo.firstName = this.userInfo.firstName
      this.generalInfo.lastName = this.userInfo.lastName
      this.generalInfo.displayName = this.userInfo.fullName
      this.generalInfo.title = this.userInfo.title
    }
    if (this.profile) {
      if (this.profile.birthDay) {
        const dateString = this.profile.birthDay
        const date = new Date(dateString)

        this.generalInfo.selectedYear = date.getUTCFullYear()
        this.generalInfo.selectedMonth = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are 0-indexed
        this.generalInfo.selectedDay = String(date.getUTCDate()).padStart(2, '0')
      }
      console.log('this.profile', this.profile)
      this.generalInfo.introdution = this.profile.introdution
      this.generalInfo.sex = this.profile.gender
      this.generalInfo.state = this.profile.stateCode ? this.profile.stateCode : this.profile.state
      this.generalInfo.city = this.profile.city
      this.generalInfo.zipcode = this.profile.zipcode
      this.generalInfo.streetName = this.profile.streetName
      this.generalInfo.streetNumber = this.profile.streetNumber
      this.generalInfo.suit = this.profile.suite
      this.generalInfo.maritalStatus = this.profile.maritalStatus
      this.generalInfo.ethnicity = this.profile.ethnicity
    }
    this.$forceUpdate()
  },
  beforeDestroy () {
  },
  methods: {}
}
</script>
<style scoped="">

</style>
